

export class CommonDialogInfo {
    dialogHeader            : string;
    dialogDescription       : string;
    dialogDeleteMessage     : string;
    dialogWatingMessage     : string;
}
